/**
 * Theme JavaScript
 */

(function () {
    "use strict";

    function initMobileMenu() {
        var menu    = document.getElementById("mobile-menu");
        var openBtn = document.getElementById("mobile-menu-open");
        var closeBtn = document.getElementById("mobile-menu-close");

        if (!menu) return;

        function openMenu() {
            menu.classList.remove("hidden");
            menu.removeAttribute("aria-hidden");
            document.body.classList.add("overflow-hidden");
            if (openBtn) openBtn.setAttribute("aria-expanded", "true");
        }

        function closeMenu() {
            menu.classList.add("hidden");
            menu.setAttribute("aria-hidden", "true");
            document.body.classList.remove("overflow-hidden");
            if (openBtn) openBtn.setAttribute("aria-expanded", "false");
        }

        if (openBtn)  openBtn.addEventListener("click", openMenu);
        if (closeBtn) closeBtn.addEventListener("click", closeMenu);

        document.addEventListener("keydown", function (e) {
            if (e.key === "Escape" && !menu.classList.contains("hidden")) closeMenu();
        });

        // Accordion
        menu.querySelectorAll(".mobile-accordion-toggle").forEach(function (toggle) {
            toggle.addEventListener("click", function () {
                var accordion = this.closest(".mobile-accordion");
                var content   = accordion.querySelector(".mobile-accordion-content");
                var chevron   = accordion.querySelector(".mobile-chevron");
                var isOpen    = content.style.display === "flex";

                content.style.display = isOpen ? "none" : "flex";
                chevron.classList.toggle("rotate-180", !isOpen);
            });
        });
    }

    function initLangSwitcher() {
        var switcher = document.querySelector(".lang-switcher");
        if (!switcher) return;

        var toggle   = switcher.querySelector(".lang-switcher-toggle");
        var dropdown = switcher.querySelector(".lang-dropdown");
        var chevron  = switcher.querySelector(".lang-chevron");

        function open() {
            dropdown.classList.remove("opacity-0", "invisible", "-translate-y-2");
            dropdown.classList.add("opacity-100", "visible", "translate-y-0");
            toggle.setAttribute("aria-expanded", "true");
            if (chevron) chevron.classList.add("rotate-180");
        }

        function close() {
            dropdown.classList.add("opacity-0", "invisible", "-translate-y-2");
            dropdown.classList.remove("opacity-100", "visible", "translate-y-0");
            toggle.setAttribute("aria-expanded", "false");
            if (chevron) chevron.classList.remove("rotate-180");
        }

        toggle.addEventListener("click", function (e) {
            e.stopPropagation();
            var isOpen = toggle.getAttribute("aria-expanded") === "true";
            isOpen ? close() : open();
        });

        document.addEventListener("click", function (e) {
            if (!switcher.contains(e.target)) close();
        });

        document.addEventListener("keydown", function (e) {
            if (e.key === "Escape") close();
        });
    }

    // Bloqueia o scroll do body sempre que uma modal (overlay .fixed.inset-0)
    // estiver visível. Observa mutações de classe/estilo em todo o documento,
    // por isso cobre todas as modais do tema sem alterações caso a caso.
    function initModalScrollLock() {
        function anyOverlayVisible() {
            var overlays = document.querySelectorAll(".fixed.inset-0");
            for (var i = 0; i < overlays.length; i++) {
                if (window.getComputedStyle(overlays[i]).display !== "none") return true;
            }
            return false;
        }

        var scheduled = false;
        function sync() {
            if (scheduled) return;
            scheduled = true;
            window.requestAnimationFrame(function () {
                scheduled = false;
                document.body.classList.toggle("overflow-hidden", anyOverlayVisible());
            });
        }

        var observer = new MutationObserver(sync);
        observer.observe(document.body, {
            attributes: true,
            attributeFilter: ["class", "style"],
            subtree: true,
            childList: true,
        });
        sync();
    }

    function initAll() {
        initMobileMenu();
        initLangSwitcher();
        initModalScrollLock();
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initAll);
    } else {
        initAll();
    }

    // Smooth scroll for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
        anchor.addEventListener("click", function (e) {
            var href = this.getAttribute("href");
            if (href !== "#" && document.querySelector(href)) {
                e.preventDefault();
                document.querySelector(href).scrollIntoView({ behavior: "smooth" });
            }
        });
    });
})();
